import React from 'react';
import ProcurementTable from './ProcurementTable';

const ProductHydroTable = props => (
  <ProcurementTable {...props} procurementTypeHeader='1' />
);

export default React.memo(ProductHydroTable);
